(function () {
  /* rb-pdp-card-v1 — full PDP in a near-fullscreen card; in-site clicks skip a page load */
  var CARD_ID = 'rb-pdp-card';
  var OPEN_CLASS = 'rb-pdp-card-open';
  var cache = {};
  var inflight = {};
  var prefetchQueued = {};
  var opening = false;
  var savedBodyClass = null;
  var savedListingScrollY = 0;
  var listingScrollSaved = false;
  var listingAnchorEl = null;
  var listingAnchorTop = 0;
  var listingRestoreTimers = [];
  var listingRestoreFinish = null;
  var savedScrollRestoration = '';
  var savedHtmlOverflow = '';
  var savedBodyOverflow = '';
  var scrollLocked = false;
  var purchaseRetryTimers = [];
  var loadedScripts = {};
  var closingOverlay = false;
  var layoutLocked = false;
  var layoutSyncTimer = 0;
  var settleUnlockTimer = 0;
  var digiohStackMo = null;
  var digiohStackTimer = 0;
  /* Pages whose main product is in a Stoq preorder plan load in full: Stoq's script, which
     attaches the preorder selling plan and its cart rules, never runs inside the overlay. */
  var fullPageHrefs = {};

  /* rb-pdp-digioh-stack-v5 — keep Digioh; pin nav under it (match collection).
     Runs on desktop too: the banner covers the fixed nav at every width. */
  function syncQuickshopDigioh() {
    if (typeof window.rbSyncDigiohTophat === 'function') window.rbSyncDigiohTophat();
  }

  /* rb-pdp-digioh-stack-mobile-v4 — lazy-loading fires mutations continuously while
     scrolling; re-measuring on each one thrashed the chrome. Coalesce into one pass. */
  function queueQuickshopDigioh() {
    if (digiohStackTimer) return;
    digiohStackTimer = window.setTimeout(function () {
      digiohStackTimer = 0;
      syncQuickshopDigioh();
    }, 200);
  }

  function startDigiohStackWatch() {
    syncQuickshopDigioh();
    if (digiohStackMo || typeof MutationObserver === 'undefined' || !document.body) return;
    digiohStackMo = new MutationObserver(queueQuickshopDigioh);
    digiohStackMo.observe(document.body, { childList: true, subtree: true });
  }

  function stopDigiohStackWatch() {
    if (digiohStackMo) {
      digiohStackMo.disconnect();
      digiohStackMo = null;
    }
    window.clearTimeout(digiohStackTimer);
    digiohStackTimer = 0;
  }

  function cardEl() {
    return document.getElementById(CARD_ID);
  }

  function scrollEl(card) {
    return card ? card.querySelector('.rb-pdp-card__scroll') : null;
  }

  function bodyEl(card) {
    return card ? card.querySelector('.rb-pdp-card__body') : null;
  }

  /* rb-pdp-mast-in-scroll-v3 — mast always first in scroller; scrolls with content */
  function mountPdpMast(card) {
    if (!card) return;
    var scroll = scrollEl(card);
    var mast = card.querySelector('.rb-pdp-card__mast');
    if (!scroll || !mast) return;
    if (mast.parentElement !== scroll) {
      scroll.insertBefore(mast, scroll.firstChild);
    }
  }

  var mastMountTimer = 0;
  function scheduleMountPdpMast(card) {
    mountPdpMast(card || cardEl());
    window.clearTimeout(mastMountTimer);
    mastMountTimer = window.setTimeout(function () {
      mountPdpMast(card || cardEl());
    }, 0);
  }

  function isNative(card) {
    return !!(card && card.getAttribute('data-rb-pdp-native') === '1');
  }

  function sameOrigin(url) {
    try {
      return new URL(url, window.location.origin).origin === window.location.origin;
    } catch (err) {
      return false;
    }
  }

  function productPath(pathname) {
    var m = String(pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* Full-page products — never open in the quickshop card */
  var SKIP_CARD_HANDLES = {
    'bundle-builder': true
  };

  function isProductUrl(href) {
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      if (!/\/products\/[^/]+/.test(u.pathname)) return false;
      if (/\/(cart|checkout|account)\b/.test(u.pathname)) return false;
      var handle = productPath(u.pathname);
      if (handle && SKIP_CARD_HANDLES[handle]) return false;
      return true;
    } catch (err) {
      return false;
    }
  }

  function withPreview(url) {
    try {
      var next = new URL(url, window.location.origin);
      var cur = new URL(window.location.href);
      ['preview_theme_id', '_ab', '_fd', 'pb'].forEach(function (key) {
        if (cur.searchParams.has(key) && !next.searchParams.has(key)) {
          next.searchParams.set(key, cur.searchParams.get(key));
        }
      });
      return next.toString();
    } catch (err) {
      return url;
    }
  }

  function lockScroll() {
    /* rb-chrome-page-top-v1 — page scrolls; Digioh + nav stay in document flow */
    scrollLocked = false;
  }

  function unlockScroll() {
    /* Always clear — do not restore a value captured during a nested lock */
    document.documentElement.style.overflow = '';
    document.documentElement.style.overflowX = '';
    document.documentElement.style.overflowY = '';
    document.body.style.overflow = '';
    document.body.style.overflowX = '';
    document.body.style.overflowY = '';
    document.documentElement.style.touchAction = '';
    document.body.style.touchAction = '';
    scrollLocked = false;
    savedHtmlOverflow = '';
    savedBodyOverflow = '';
  }

  function clearPurchaseRetries() {
    purchaseRetryTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    purchaseRetryTimers = [];
  }

  function destroyCardWidgets(root) {
    destroyRechargeWidgets();
    if (!root || !window.jQuery) return;
    try {
      window.jQuery(root).find('.flickityt4s.flickityt4s-enabled').each(function () {
        try {
          window.jQuery(this).flickityt4s('destroy');
        } catch (err) {}
      });
    } catch (err2) {}
  }

  /* rb-pdp-close-cleanup-v1 — product scripts leave sticky ATC / glow / active cards on the listing */
  function clearVariantGlowShell() {
    function clear(el) {
      if (!el || !el.style) return;
      el.style.removeProperty('--rb-variant-glow');
      el.style.removeProperty('--rb-feature-color');
      el.style.removeProperty('--rb-feature-mid');
      el.style.removeProperty('--rb-atc-hover-gradient');
      el.style.removeProperty('--rb-atc-hover-gradient-static');
      el.style.removeProperty('--rb-atc-hover-gradient-size');
    }
    clear(document.documentElement);
    clear(document.body);
  }

  function removeOrphanProductChrome() {
    var card = cardEl();
    document.querySelectorAll('[data-sticky-addtocart], .t4s-sticky-atc').forEach(function (el) {
      if (card && card.contains(el)) return;
      try {
        el.remove();
      } catch (err) {}
    });
    document.body.classList.remove('sticky-is--active', 'sticky-atc-bar-enabled');
  }

  var stickyAtcWatch = null;
  var stickyAtcCleanupTimers = [];

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function suppressStickyAtc() {
    removeOrphanProductChrome();
  }

  function scheduleStickyAtcCleanup() {
    stickyAtcCleanupTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    stickyAtcCleanupTimers = [];
    [0, 50, 200, 500, 1200].forEach(function (ms) {
      stickyAtcCleanupTimers.push(
        window.setTimeout(function () {
          suppressStickyAtc();
        }, ms)
      );
    });
  }

  function startStickyAtcWatch() {
    if (!isDesktopViewport() || !window.MutationObserver) return;
    stopStickyAtcWatch();
    suppressStickyAtc();
    stickyAtcWatch = new MutationObserver(function () {
      if (!document.documentElement.classList.contains(OPEN_CLASS)) return;
      suppressStickyAtc();
    });
    stickyAtcWatch.observe(document.body, { childList: true, subtree: true });
  }

  function stopStickyAtcWatch() {
    if (stickyAtcWatch) {
      stickyAtcWatch.disconnect();
      stickyAtcWatch = null;
    }
    stickyAtcCleanupTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    stickyAtcCleanupTimers = [];
  }

  function cleanupAfterCardClose() {
    clearVariantGlowShell();
    stopStickyAtcWatch();
    suppressStickyAtc();
    scheduleStickyAtcCleanup();
    document.querySelectorAll('#MainContent .rb-product.is-carousel-active').forEach(function (el) {
      el.classList.remove('is-carousel-active');
    });
    try {
      if (typeof window.rbSyncCollectionCardHighlight === 'function') {
        window.rbSyncCollectionCardHighlight();
      }
    } catch (err) {}
  }

  /* rb-pdp-nav-scroll-hide-v2 — dedicated html class (avoids body.rb-scrolled style thrash) */
  var NAV_HIDDEN = 'rb-pdp-nav-hidden';
  var cardHeaderScrollBound = null;
  var cardHeaderScrollState = null;

  function stopCardHeaderScroll() {
    if (cardHeaderScrollBound && cardHeaderScrollBound.el && cardHeaderScrollBound.onScroll) {
      cardHeaderScrollBound.el.removeEventListener('scroll', cardHeaderScrollBound.onScroll);
    }
    cardHeaderScrollBound = null;
    cardHeaderScrollState = null;
    document.documentElement.classList.remove(NAV_HIDDEN);
    document.body.classList.remove('rb-scrolled');
  }

  function revealCardNav(opts) {
    document.documentElement.classList.remove(NAV_HIDDEN);
    document.body.classList.remove('rb-scrolled');
    if (cardHeaderScrollState) {
      cardHeaderScrollState.isHidden = false;
      cardHeaderScrollState.scrollAccumulator = 0;
      cardHeaderScrollState.maxWhileHidden = 0;
      cardHeaderScrollState.lastY = 0;
      /* Ignore layout/scroll jumps right after PDP→PDP inject so nav stays visible */
      var quietMs = opts && opts.quietMs != null ? opts.quietMs : 700;
      cardHeaderScrollState.ignoreUntil = Date.now() + quietMs;
    }
  }

  function startCardHeaderScroll() {
    /* rb-chrome-pin-v1 — Digioh + main nav stay fixed; no scroll drawer */
    stopCardHeaderScroll();
    document.documentElement.classList.remove(NAV_HIDDEN);
    document.body.classList.remove('rb-scrolled');
  }

  var ARROW_TUCK = 'rb-pdp-arrow-tuck';
  var ARROW_HIDDEN = 'rb-pdp-arrow-hidden';
  var ARROW_FLOW = 'rb-pdp-arrow-flow';
  var FLOW_TOP = 18;
  var ARROW_DEADZONE = 6;
  var arrowLastY = -1;
  var arrowTuckBound = false;
  var arrowTuckTick = 0;

  function pdpArrowBtn() {
    return document.querySelector('.rb-pdp-card__close');
  }

  function pdpArrowIsMobile() {
    return window.matchMedia('(max-width: 999px) and (hover: none), (max-width: 999px) and (pointer: coarse)').matches;
  }

  function clearPdpArrowTop() {
    var btn = pdpArrowBtn();
    if (btn) btn.style.removeProperty('top');
  }

  function pdpPageScale() {
    var root = document.documentElement;
    if (!root.classList.contains('rb-desktop-scale')) return 1;
    var s = parseFloat(getComputedStyle(root).getPropertyValue('--rb-desktop-scale'));
    return s > 0 ? s : 1;
  }

  /* rb-pdp-arrow-scaled-fixed-v1 — below the design width, rb-desktop-scale puts
     transform:scale on <html>. A transformed ancestor becomes the containing block for its
     position:fixed children, so `top` stops meaning "from the top of the viewport" and the
     arrow scrolls off the screen with the page. Convert the viewport spot we want into that
     scaled coordinate space: painted y = top * scale - scrollY, so top = (y + scrollY)/scale. */
  function pdpArrowFixedTop(viewportTop, scrollY) {
    var scale = pdpPageScale();
    if (scale === 1) return viewportTop;
    return (viewportTop + scrollY) / scale;
  }

  function pdpArrowChromeBottom() {
    var bottom = 0;
    var header = document.querySelector('.rb-header');
    if (header) {
      var hr = header.getBoundingClientRect();
      if (hr.height > 8) bottom = Math.max(bottom, hr.bottom);
    }
    var digioh = document.querySelector('.preloaded_lightbox, .rb-digioh-tophat, .rb-pdp-digioh-banner');
    if (digioh && digioh !== document.documentElement && digioh !== document.body) {
      var dr = digioh.getBoundingClientRect();
      /* Ignore the force-loaded box while it is still at the document bottom */
      if (dr.height >= 16 && dr.height <= 260 && dr.top > -4 && dr.top < 80) {
        bottom = Math.max(bottom, dr.bottom);
      }
    }
    return bottom;
  }

  /* rb-pdp-arrow-scroll-v3 — two earlier attempts, both wrong for the same underlying reason.
     Re-measuring the chrome and writing `top` every scroll frame made the arrow judder, and
     parking it in two spots instead meant it had to vanish for the stretch where the header
     still covered the tucked spot. Neither is necessary: the arrow lives in the mast, which
     scrolls at the same rate as the header, so simply leaving it in normal flow holds it a
     constant distance below the header all the way up — the page does the moving, not JS.
     When that natural spot arrives at `snug` it pins there for the rest of the scroll. The
     two states line up at the swap, so there is nothing to see. */
  function syncPdpArrowMobile(root, btn, scrollY, snug, gap) {
    btn.style.removeProperty('top');
    var mast = btn.closest ? btn.closest('.rb-pdp-card__mast') : null;
    /* FLOW_TOP mirrors the flow rule's `top` in rb-mobile.css. */
    var naturalTop = mast ? mast.getBoundingClientRect().top + FLOW_TOP : pdpArrowChromeBottom() + gap;
    var pinned = naturalTop <= snug;
    root.classList.toggle(ARROW_TUCK, pinned);
    root.classList.toggle(ARROW_FLOW, !pinned);
  }

  /* rb-pdp-arrow-fade-v1 — scroll direction decides visibility only. Position is left alone,
     so the arrow fades out wherever it stands and fades back in at the same spot. At the top
     of the page there is no direction yet, so it stays up. The deadzone keeps momentum jitter
     from flipping it on every frame. */
  function syncPdpArrowFade(root, scrollY) {
    if (scrollY < 8) {
      root.classList.remove(ARROW_HIDDEN);
      arrowLastY = scrollY;
      return;
    }
    if (arrowLastY < 0) {
      arrowLastY = scrollY;
      return;
    }
    var delta = scrollY - arrowLastY;
    if (Math.abs(delta) < ARROW_DEADZONE) return;
    arrowLastY = scrollY;
    root.classList.toggle(ARROW_HIDDEN, delta > 0);
  }

  function syncPdpArrowTuck() {
    /* rb-pdp-arrow-onload-v2 — sit under chrome on first paint; do not wait for scroll */
    var root = document.documentElement;
    var btn = pdpArrowBtn();
    if (!root.classList.contains(OPEN_CLASS) || !btn) {
      root.classList.remove(ARROW_TUCK, ARROW_HIDDEN, ARROW_FLOW);
      clearPdpArrowTop();
      return;
    }
    var mobile = pdpArrowIsMobile();
    var snug = mobile ? 10 : 12;
    var gap = mobile ? 18 : 10;
    var bar = mobile ? 98 : 106;
    var scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    syncPdpArrowFade(root, scrollY);
    if (mobile) return syncPdpArrowMobile(root, btn, scrollY, snug, gap);
    var reserved = parseFloat(getComputedStyle(root).getPropertyValue('--rb-digioh-tophat-height')) || 0;
    var top = Math.max(snug, pdpArrowChromeBottom() + gap);
    if (scrollY < 8) {
      top = Math.max(top, reserved + bar + gap);
      root.classList.remove(ARROW_TUCK);
    } else {
      root.classList.toggle(ARROW_TUCK, top <= snug + 0.5);
    }
    btn.style.setProperty('top', Math.round(pdpArrowFixedTop(top, scrollY)) + 'px', 'important');
  }
  window.rbSyncPdpArrowTuck = syncPdpArrowTuck;

  function onPdpArrowTuckScroll() {
    if (arrowTuckTick) return;
    arrowTuckTick = window.requestAnimationFrame(function () {
      arrowTuckTick = 0;
      syncPdpArrowTuck();
    });
  }

  function startPdpArrowTuck() {
    if (!arrowTuckBound) {
      arrowTuckBound = true;
      window.addEventListener('scroll', onPdpArrowTuckScroll, { passive: true, capture: true });
      window.addEventListener('resize', onPdpArrowTuckScroll);
    }
    arrowLastY = -1;
    document.documentElement.classList.remove(ARROW_HIDDEN, ARROW_FLOW);
    syncPdpArrowTuck();
    window.requestAnimationFrame(syncPdpArrowTuck);
    [0, 80, 250, 600, 1400, 2800, 4500].forEach(function (ms) {
      window.setTimeout(syncPdpArrowTuck, ms);
    });
  }

  function stopPdpArrowTuck() {
    document.documentElement.classList.remove(ARROW_TUCK, ARROW_HIDDEN, ARROW_FLOW);
    arrowLastY = -1;
    clearPdpArrowTop();
    if (!arrowTuckBound) return;
    arrowTuckBound = false;
    window.removeEventListener('scroll', onPdpArrowTuckScroll, { capture: true });
    window.removeEventListener('resize', onPdpArrowTuckScroll);
    if (arrowTuckTick) {
      window.cancelAnimationFrame(arrowTuckTick);
      arrowTuckTick = 0;
    }
  }

  /* rb-pdp-listing-anchor-v1 — the card pins the window to 0 while it is open, so closing
     has to put the listing back itself. */
  function currentScrollY() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function noteListingAnchor(a) {
    /* The tapped card beats a raw pixel offset when the grid re-measures on the way back.
       Only the click that opens the card sees the listing — later ones are inside it. */
    if (!a || !a.closest || listingScrollSaved) return;
    var card = a.closest('.rb-product, .t4s-product, .t4s-product-inner, li');
    var el = card || a;
    var rect = el.getBoundingClientRect();
    if (!rect.height && !rect.width) return;
    listingAnchorEl = el;
    listingAnchorTop = rect.top;
  }

  function captureListingScroll() {
    /* Once per overlay session — a product-to-product jump inside the card would otherwise
       overwrite the listing offset with the card's pinned 0 */
    if (listingScrollSaved) return;
    savedListingScrollY = currentScrollY();
    listingScrollSaved = true;
  }

  function holdScrollRestoration() {
    /* Back gesture: the browser reapplies the offset it recorded for this entry (0, taken
       while the card had the page pinned) right after popstate, undoing our restore */
    if (isNative(cardEl())) return;
    try {
      if (!('scrollRestoration' in window.history)) return;
      if (savedScrollRestoration === '') savedScrollRestoration = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
    } catch (err) {}
  }

  function releaseScrollRestoration() {
    try {
      if (savedScrollRestoration === '' || !('scrollRestoration' in window.history)) return;
      window.history.scrollRestoration = savedScrollRestoration;
    } catch (err) {}
    savedScrollRestoration = '';
  }

  function clearListingRestore() {
    listingRestoreTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    listingRestoreTimers = [];
    if (listingRestoreFinish) listingRestoreFinish();
  }

  function scrollWindowTo(y) {
    try {
      window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    } catch (err) {
      try {
        window.scrollTo(0, y);
      } catch (err2) {
        document.documentElement.scrollTop = y;
      }
    }
  }

  function anchorDelta() {
    if (!listingAnchorEl || !listingAnchorEl.isConnected || !listingAnchorEl.offsetParent) return 0;
    var rect = listingAnchorEl.getBoundingClientRect();
    if (!rect.height && !rect.width) return 0;
    var delta = rect.top - listingAnchorTop;
    if (Math.abs(delta) < 2 || Math.abs(delta) > 4000) return 0;
    return delta;
  }

  function restoreListingScroll() {
    var target = Math.max(0, savedListingScrollY || 0);
    listingScrollSaved = false;
    clearListingRestore();
    if (!target) {
      listingAnchorEl = null;
      releaseScrollRestoration();
      return;
    }
    var settled = false;
    var firstPass = true;
    function finish() {
      if (settled) return;
      settled = true;
      window.removeEventListener('touchstart', finish, true);
      window.removeEventListener('wheel', finish, true);
      listingRestoreFinish = null;
      releaseScrollRestoration();
    }
    listingRestoreFinish = finish;
    /* A flick right after close owns the scroll — never yank it back */
    window.addEventListener('touchstart', finish, { passive: true, capture: true });
    window.addEventListener('wheel', finish, { passive: true, capture: true });
    function apply() {
      if (settled) return;
      /* Reading scrollHeight flushes the layout the class removal just invalidated. Without
         it the footer is still display:none and the target clamps short of where it was. */
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      /* Only trust the anchor once the pixel target is reached — before that the gap is the
         clamp, not a layout shift */
      if (!firstPass && Math.abs(currentScrollY() - target) <= 1) {
        target = Math.max(0, target + anchorDelta());
      }
      firstPass = false;
      var want = Math.min(target, max);
      if (Math.abs(currentScrollY() - want) > 1) scrollWindowTo(want);
      if (max >= target && Math.abs(currentScrollY() - target) <= 1 && !anchorDelta()) finish();
    }
    apply();
    window.requestAnimationFrame(apply);
    /* The restored footer and any late media keep the page height moving for a beat */
    [0, 60, 140, 260, 420].forEach(function (ms) {
      listingRestoreTimers.push(
        window.setTimeout(function () {
          apply();
          if (ms === 420) finish();
        }, ms)
      );
    });
  }

  function markOpen() {
    clearListingRestore();
    captureListingScroll();
    holdScrollRestoration();
    document.documentElement.classList.add(OPEN_CLASS);
    document.documentElement.classList.remove(NAV_HIDDEN);
    lockScroll();
    document.body.classList.remove('rb-scrolled');
    startPdpArrowTuck();
    /* rb-pdp-desk-scale-scroll-v1 — overlay must not inherit the scaled html height clamp */
    document.documentElement.style.removeProperty('height');
    if (typeof window.rbSyncDesktopScale === 'function') window.rbSyncDesktopScale();
    bindQuickshopScrollGuard();
    muteScrollIntoView(1500);
    pinQuickshopTop(cardEl());
    startDigiohStackWatch();
    startStickyAtcWatch();
    variantUrlLast = '';
    scheduleVariantUrlSync();
  }

  function prepareListingNavForClose() {
    document.documentElement.classList.remove(NAV_HIDDEN);
    document.body.classList.remove('rb-scrolled');
    if (savedBodyClass != null) {
      document.body.className = savedBodyClass
        .replace(/\brb-scrolled\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();
      savedBodyClass = null;
    }
  }

  function markClosed() {
    stopPdpArrowTuck();
    stopCardHeaderScroll();
    stopDigiohStackWatch();
    clearVariantUrlTimers();
    variantUrlLast = '';
    prepareListingNavForClose();
    unlockScroll();
    cleanupAfterCardClose();
    /* Drop quickshop chrome after listing nav state is settled — avoids nav flash */
    window.requestAnimationFrame(function () {
      document.documentElement.classList.remove(OPEN_CLASS);
      if (typeof window.rbSyncDigiohTophat === 'function') window.rbSyncDigiohTophat();
      if (typeof window.rbSyncDesktopScale === 'function') window.rbSyncDesktopScale();
      restoreListingScroll();
    });
  }

  function applyProductBodyClass() {
    /* Always remember the listing body once per overlay session */
    if (savedBodyClass == null) {
      savedBodyClass = document.body.className;
    }
    if (document.body.classList.contains('template-product')) return;
    document.body.className = document.body.className
      .replace(/\btemplate-[a-z0-9-]+\b/g, 'template-product')
      .replace(/\s+/g, ' ')
      .trim();
    if (!/\btemplate-product\b/.test(document.body.className)) {
      document.body.className += ' template-product';
    }
  }

  function setOpen(card, open) {
    if (!card) return;
    if (open) {
      scheduleMountPdpMast(card);
      card.classList.add('is-open');
      card.removeAttribute('hidden');
      markOpen();
      lockCardScrollY(card);
      resetCardScroll(card);
      startCardHeaderScroll(card);
    } else {
      card.classList.remove('is-open');
      card.setAttribute('hidden', '');
      markClosed();
    }
  }

  function loadScriptOnce(src) {
    if (!src) return Promise.resolve();
    var key = src.split('?')[0];
    if (loadedScripts[key] || document.querySelector('script[src^="' + key + '"]')) {
      loadedScripts[key] = true;
      return Promise.resolve();
    }
    loadedScripts[key] = true;
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        resolve();
      };
      document.body.appendChild(s);
    });
  }

  var moduleInflight = {};

  function loadModuleOnce(src) {
    if (!src) return Promise.resolve();
    var key = 'rcmod:' + src.split('?')[0];
    if (moduleInflight[key]) return moduleInflight[key];
    if (loadedScripts[key]) return Promise.resolve();
    moduleInflight[key] = new Promise(function (resolve) {
      if (window.Recharge) {
        loadedScripts[key] = true;
        resolve();
        return;
      }
      var s = document.createElement('script');
      s.type = 'module';
      s.crossOrigin = 'anonymous';
      s.src = src;
      s.onload = function () {
        loadedScripts[key] = true;
        resolve();
      };
      s.onerror = function () {
        resolve();
      };
      document.head.appendChild(s);
    });
    return moduleInflight[key];
  }

  function isRechargeScript(node) {
    var src = node.getAttribute('src') || node.src || '';
    if (src.indexOf('rc-widget') !== -1) return true;
    if (!src && /initRecharge/.test(node.textContent || '')) return true;
    return false;
  }

  function hoistLink(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    var rel = link.getAttribute('rel') || '';
    if (!document.querySelector('head link[rel="' + rel + '"][href="' + href + '"]')) {
      var next = document.createElement('link');
      next.rel = rel;
      next.href = href;
      if (rel === 'modulepreload' || link.crossOrigin) next.crossOrigin = 'anonymous';
      if (link.getAttribute('type')) next.type = link.getAttribute('type');
      document.head.appendChild(next);
    }
  }

  function rechargeReady(widget) {
    /* rb-pdp-rc-ready-v1 — empty .rc-widget shell is not ready */
    return !!(widget && widget.querySelector('.rc-radio'));
  }

  function warmupRecharge(root) {
    if (!root) return;
    var widget = root.querySelector('.recharge-subscription-widget');
    if (!widget) return;
    widget.querySelectorAll('link').forEach(hoistLink);
    var mod = widget.querySelector('script[src*="rc-widget"]');
    var src = mod ? mod.getAttribute('src') || '' : '';
    if (src) loadModuleOnce(src);
  }

  function destroyRechargeWidgets() {
    try {
      var bag = window.Recharge && window.Recharge.widgets;
      if (!bag) return;
      Object.keys(bag).forEach(function (id) {
        var inst = bag[id];
        if (inst && typeof inst.destroy === 'function') inst.destroy();
        delete bag[id];
      });
    } catch (err) {}
  }

  function stripRechargeAutoInit(code) {
    return String(code || '').replace(
      /if\s*\(\s*window\.Recharge\s*\)\s*\{[\s\S]*?onRechargeLoad\s*=\s*initRecharge;\s*\}/,
      ''
    );
  }

  function neutralizeRecharge(root) {
    /* rb-pdp-rc-mobile-v2 — stop hidden ReCharge from owning selling_plan */
    if (!root) return;
    root.querySelectorAll('.recharge-subscription-widget, .rc-widget, [id^="RechargeWidget"]').forEach(function (widget) {
      widget.setAttribute('hidden', '');
      widget.setAttribute('aria-hidden', 'true');
      widget.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.disabled = true;
        if (el.getAttribute('name') === 'selling_plan') el.removeAttribute('name');
      });
    });
  }

  function undoNeutralizeRecharge(root) {
    if (!root) return;
    root.querySelectorAll('.recharge-subscription-widget, .rc-widget, [id^="RechargeWidget"]').forEach(function (widget) {
      widget.removeAttribute('hidden');
      widget.removeAttribute('aria-hidden');
      widget.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.disabled = false;
      });
    });
  }

  function backupPurchase(root) {
    var el = root && root.querySelector('[data-rb-subscribe]');
    if (!el) return null;
    var clone = el.cloneNode(true);
    clone.removeAttribute('data-rb-sub-inited');
    return clone;
  }

  function restorePurchase(root, backup) {
    if (!root || !backup || root.querySelector('[data-rb-subscribe]')) return;
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var node = backup.cloneNode(true);
    node.removeAttribute('data-rb-sub-inited');
    var hook = form.querySelector('.sbs_message') || form.querySelector('.t4s-product-form__buttons');
    if (hook) form.insertBefore(node, hook);
    else form.appendChild(node);
  }

  function initCardPurchase(root) {
    /* rb-pdp-card-purchase-v1 — server-rendered pills in quickshop; skip ReCharge everywhere */
    if (!root) return false;
    var pills = root.querySelector('[data-rb-subscribe]');
    if (pills) {
      neutralizeRecharge(root);
      pills.removeAttribute('data-rb-sub-inited');
      if (typeof window.rbInitProductSubscribe === 'function') {
        window.rbInitProductSubscribe(root);
      }
      return true;
    }
    return false;
  }

  function schedulePurchaseRetries(root, purchaseBackup) {
    [50, 150, 400, 1000, 2500].forEach(function (ms) {
      purchaseRetryTimers.push(
        window.setTimeout(function () {
          restorePurchase(root, purchaseBackup);
          initCardPurchase(root);
        }, ms)
      );
    });
  }

  function resetCardScroll(card) {
    try {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } catch (err) {}
    if (!card) return;
    [card, scrollEl(card), card.querySelector('.rb-pdp-card__panel'), card.querySelector('.rb-pdp-card__body')].forEach(function (el) {
      if (el) el.scrollTop = 0;
    });
    /* Product jump — always show nav on load; drawer only after user scrolls */
    revealCardNav({ quietMs: 700 });
  }

  function pinQuickshopTop(card) {
    /* rb-chrome-page-top-v1 — open at page start once; do not keep yanking scroll to 0 */
    resetCardScroll(card || cardEl());
  }

  var scrollIntoViewOrig = null;
  function muteScrollIntoView(ms) {
    if (!scrollIntoViewOrig) scrollIntoViewOrig = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {};
    window.setTimeout(function () {
      if (scrollIntoViewOrig) Element.prototype.scrollIntoView = scrollIntoViewOrig;
    }, ms || 1500);
  }

  function bindQuickshopScrollGuard() {
    /* rb-chrome-page-top-v1 — window scroll is the page; do not pin it to 0 */
  }

  /* rb-pdp-ymal-rc-v1 — YMAL / second product: run THIS product's initRecharge, not the previous one */
  function bootRechargeWidget(root) {
    var widget = root.querySelector('.recharge-subscription-widget') || root.querySelector('[id^="RechargeWidget"]');
    if (!widget) return Promise.resolve();
    widget.removeAttribute('data-rb-rc-inited');
    var scope = widget.closest('form') || root;
    scope.querySelectorAll('link').forEach(hoistLink);
    var src = '';
    var inlineCode = '';
    scope.querySelectorAll('script').forEach(function (node) {
      var href = node.getAttribute('src') || '';
      if (href.indexOf('rc-widget') !== -1) {
        src = href;
        node.remove();
      } else if ((node.textContent || '').indexOf('function initRecharge') !== -1) {
        inlineCode = stripRechargeAutoInit(node.textContent);
        node.remove();
      }
    });
    if (inlineCode) {
      try {
        var s = document.createElement('script');
        s.textContent = inlineCode;
        widget.appendChild(s);
      } catch (err2) {}
    }
    if (!isMobileCard()) destroyRechargeWidgets();
    var started = false;
    function startInit() {
      if (started || rechargeReady(widget) || rechargeReady(root)) return;
      if (typeof window.initRecharge !== 'function' || !window.Recharge) return;
      started = true;
      try {
        window.initRecharge();
      } catch (err3) {
        started = false;
      }
    }
    window.onRechargeLoad = function () {
      startInit();
    };
    return loadModuleOnce(src).then(function () {
      startInit();
      if (rechargeReady(widget) || rechargeReady(root)) {
        widget.setAttribute('data-rb-rc-inited', '1');
        return;
      }
      return new Promise(function (resolve) {
        var tries = 0;
        var timer = window.setInterval(function () {
          tries += 1;
          if (!started) startInit();
          if (rechargeReady(widget) || rechargeReady(root)) {
            widget.setAttribute('data-rb-rc-inited', '1');
            window.clearInterval(timer);
            resolve();
            return;
          }
          if (tries > 100) {
            window.clearInterval(timer);
            resolve();
          }
        }, 50);
      });
    });
  }

  function executeScripts(root) {
    var nodes = root.querySelectorAll('script');
    var jobs = [];
    nodes.forEach(function (old) {
      if (isRechargeScript(old)) return;
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'application/javascript' && type !== 'module') {
        return;
      }
      if (old.src) {
        jobs.push(loadScriptOnce(old.src));
        old.remove();
        return;
      }
      try {
        var s = document.createElement('script');
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      } catch (err) {}
    });
    return Promise.all(jobs);
  }

  function refreshYotpo(root) {
    try {
      if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
        window.yotpo.initWidgets();
      }
    } catch (err) {}
    root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  function initPdpGallery(root) {
    if (!root || !window.T4SThemeSP || typeof T4SThemeSP.Carousel !== 'function') return;
    root.querySelectorAll('.flickityt4s:not(.flickityt4s-later):not(.flickityt4s-enabled)').forEach(function (el) {
      try {
        el.flickityt4s = new T4SThemeSP.Carousel(el);
      } catch (err) {}
    });
    lockMobileGalleryDrag(root);
  }

  function resizePdpGallery(root) {
    if (!root || !window.jQuery) return;
    try {
      var $g = window.jQuery(root).find('.flickityt4s.flickityt4s-enabled[data-main-media]');
      if ($g.length) $g.flickityt4s('resize');
    } catch (err) {}
    lockMobileGalleryDrag(root);
  }

  function reinitThemeProduct(root) {
    /* rb-pdp-gallery-init-v1 — overlay HTML is injected after the page's first carousel scan */
    try {
      initPdpGallery(root);
    } catch (err0) {}
    try {
      if (window.T4SThemeSP && typeof T4SThemeSP._initProducts === 'function') {
        T4SThemeSP._initProducts();
      }
    } catch (err) {}
    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    } catch (err2) {}
    try {
      if (window.T4SThemeSP && T4SThemeSP.ProductItem && typeof T4SThemeSP.ProductItem.reloadReview === 'function') {
        T4SThemeSP.ProductItem.reloadReview();
      }
    } catch (err3) {}
    try {
      if (window.jQuery) {
        window.jQuery(document).trigger('currency:update');
      }
    } catch (err4) {}
    try {
      if (typeof window.rbInitProductCardCarousels === 'function') {
        window.rbInitProductCardCarousels(root);
      }
    } catch (err5) {}
    try {
      if (typeof window.rbInitVariantGlow === 'function') {
        window.rbInitVariantGlow(root);
      }
    } catch (err6) {}
  }

  function reinitApps(root) {
    try {
      if (window.GiftKart && typeof window.GiftKart.init === 'function') {
        window.GiftKart.init();
      }
    } catch (err) {}
    try {
      if (typeof window.initGiftKart === 'function') window.initGiftKart();
    } catch (err2) {}
    refreshYotpo(root);
  }

  function loadRecommendations(root) {
    var section = root.querySelector('.product-recommendations');
    if (!section || !section.dataset.url) return;
    if (section.querySelector('.rb-ymal:not(.rb-ymal--loading)')) {
      if (typeof window.rbInitProductCardCarousels === 'function') {
        window.rbInitProductCardCarousels(section);
      }
      return;
    }
    fetch(section.dataset.url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var wrap = document.createElement('div');
        wrap.innerHTML = text;
        var recs = wrap.querySelector('.product-recommendations');
        if (!recs || !recs.innerHTML.trim()) return;
        section.innerHTML = recs.innerHTML;
        section.classList.remove('is-loading');
        if (typeof window.rbInitProductCardCarousels === 'function') {
          window.rbInitProductCardCarousels(section);
        }
      })
      .catch(function () {});
  }

  function isDesktopCard() {
    if (window.rbIsDesktopClient && window.rbIsDesktopClient()) return true;
    return window.matchMedia && window.matchMedia('(min-width: 1024px)').matches;
  }

  function isMobileCard() {
    /* rb-desktop-scale-v1: resized desktop ≠ mobile card layout */
    if (window.rbIsDesktopClient && window.rbIsDesktopClient()) return false;
    try {
      return window.matchMedia(
        '(max-width: 999px) and (hover: none), (max-width: 999px) and (pointer: coarse)'
      ).matches;
    } catch (e) {
      return window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
    }
  }

  function lockMobileGalleryDrag(root) {
    if (!isMobileCard() || !root || !window.jQuery) return;
    try {
      var $g = window.jQuery(root).find('.flickityt4s.flickityt4s-enabled');
      if ($g.length) $g.flickityt4s('unbindDrag');
    } catch (err) {}
  }

  function isCardCarouselTarget(node) {
    return !!(node && node.closest && node.closest('[data-rb-featured-track]'));
  }

  function lockCardScrollY(card) {
    /* rb-pdp-scroll-y-only-v2 — vertical quickshop scroll; YMAL carousel keeps horizontal swipe */
    if (!isMobileCard()) return;
    var scroll = scrollEl(card);
    if (!scroll || scroll.getAttribute('data-rb-pdp-scroll-y') === '1') return;
    scroll.setAttribute('data-rb-pdp-scroll-y', '1');
    var startX = 0;
    var startY = 0;
    var carouselTouch = false;
    scroll.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || !event.touches[0]) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        carouselTouch = isCardCarouselTarget(event.target);
      },
      { passive: true, capture: true }
    );
    scroll.addEventListener(
      'touchmove',
      function (event) {
        if (carouselTouch || isCardCarouselTarget(event.target)) return;
        scroll.scrollLeft = 0;
        if (!event.touches || !event.touches[0]) return;
        var dx = Math.abs(event.touches[0].clientX - startX);
        var dy = Math.abs(event.touches[0].clientY - startY);
        if (dx > dy && dx > 8) event.preventDefault();
      },
      { passive: false, capture: true }
    );
    scroll.addEventListener(
      'touchend',
      function () {
        carouselTouch = false;
      },
      { passive: true, capture: true }
    );
    scroll.addEventListener(
      'touchcancel',
      function () {
        carouselTouch = false;
      },
      { passive: true, capture: true }
    );
  }

  function clearPdpMediaClip(media) {
    if (!media) return;
    /* rb-pdp-media-contain-v1 — do not lock gallery to a scaled getBoundingClientRect
       (visual px written as layout px → overflow:hidden crops the jar on load). */
    media.style.removeProperty('height');
    media.style.removeProperty('max-height');
    media.style.setProperty('min-height', '0', 'important');
    media.style.setProperty('overflow', 'visible', 'important');
  }

  function syncPdpMediaHeight(root, opts) {
    opts = opts || {};
    if (!isDesktopCard()) return;
    if (layoutLocked && !opts.force) return;
    var scope = root || document;
    var row = scope.querySelector('.t4s-row__product');
    if (!row) return;
    var info = row.querySelector('.t4s-product__info-wrapper');
    var media = row.querySelector('.t4s-product__media-wrapper');
    if (!info || !media) return;
    info.style.setProperty('height', 'auto', 'important');
    info.style.setProperty('min-height', '0', 'important');
    info.style.setProperty('align-self', 'start', 'important');
    clearPdpMediaClip(media);
  }

  function queuePdpLayoutSync(root) {
    if (layoutLocked) return;
    window.clearTimeout(layoutSyncTimer);
    layoutSyncTimer = window.setTimeout(function () {
      syncPdpMediaHeight(root);
      resizePdpGallery(root);
    }, 100);
  }

  function watchPdpLayout(root) {
    if (!root || !window.ResizeObserver) return;
    var info = root.querySelector('.t4s-product__info-wrapper');
    if (!info || info.getAttribute('data-rb-pdp-hug') === '1') return;
    info.setAttribute('data-rb-pdp-hug', '1');
    var obs = new ResizeObserver(function () {
      queuePdpLayoutSync(root);
    });
    obs.observe(info);
    var rc = root.querySelector('.recharge-subscription-widget, .rc-widget');
    if (rc) obs.observe(rc);
  }

  function schedulePdpLayout(root) {
    syncPdpMediaHeight(root, { force: !layoutLocked });
    watchPdpLayout(root);
    window.requestAnimationFrame(function () {
      syncPdpMediaHeight(root, { force: !layoutLocked });
      resizePdpGallery(root);
    });
    [80, 220].forEach(function (ms) {
      window.setTimeout(function () {
        if (layoutLocked) return;
        syncPdpMediaHeight(root);
        resizePdpGallery(root);
      }, ms);
    });
  }

  function waitMainImages(root, timeoutMs) {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }
      window.setTimeout(finish, timeoutMs || 300);
      if (!root) {
        finish();
        return;
      }
      var imgs = root.querySelectorAll(
        '.t4s-product__media-wrapper img, .t4s-product__media img, [data-main-media] img'
      );
      var pending = 0;
      function onOne() {
        pending -= 1;
        if (pending <= 0) finish();
      }
      for (var i = 0; i < Math.min(imgs.length, 2); i += 1) {
        var img = imgs[i];
        if (!img || (img.complete && img.naturalWidth > 0)) continue;
        pending += 1;
        img.addEventListener('load', onOne, { once: true });
        img.addEventListener('error', onOne, { once: true });
      }
      if (pending === 0) finish();
    });
  }

  function settleCard(card, root) {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        syncPdpMediaHeight(root || card, { force: true });
        resizePdpGallery(root || card);
        window.requestAnimationFrame(function () {
          syncPdpMediaHeight(root || card, { force: true });
          resizePdpGallery(root || card);
          layoutLocked = true;
          markPdpReady(root || card);
          if (card) card.classList.remove('is-loading');
          /* PDP→PDP settle can fire layout scroll — keep nav visible until user scrolls */
          resetCardScroll(card);
          window.clearTimeout(settleUnlockTimer);
          /* Allow later interaction resizes (S&S freq) after the open bounce window */
          settleUnlockTimer = window.setTimeout(function () {
            layoutLocked = false;
          }, 700);
          resolve();
        });
      });
    });
  }

  function markPdpReady(root) {
    var scope = root || document;
    var row = scope.querySelector('.t4s-row__product');
    if (row) row.setAttribute('data-rb-pdp-ready', '1');
  }

  function hydrate(root) {
    clearPurchaseRetries();
    var purchaseBackup = backupPurchase(root);
    initCardPurchase(root);
    return executeScripts(root).then(function () {
      try {
        if (typeof window.rbInitVariantGlow === 'function') {
          window.rbInitVariantGlow(root);
        }
      } catch (errGlow) {}
      reinitThemeProduct(root);
      reinitApps(root);
      loadRecommendations(root);
      schedulePdpLayout(root);
      restorePurchase(root, purchaseBackup);
      initCardPurchase(root);
      schedulePurchaseRetries(root, purchaseBackup);
      suppressStickyAtc();
      scheduleVariantUrlSync();
    });
  }

  function parseMain(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var main = doc.getElementById('MainContent');
    var title = doc.querySelector('title');
    return {
      html: main ? main.innerHTML : '',
      title: title ? title.textContent : document.title
    };
  }

  function stripGhostLineItemField(root) {
    var wholesale = typeof window.WSAIO !== 'undefined' && typeof window.WSAIO.productDiscount === 'function';
    if (wholesale) return;
    var scope = root || document;
    scope.querySelectorAll('.line-item-property__field').forEach(function (el) {
      el.remove();
    });
  }

  function productBrandKey(root) {
    var title = '';
    var heading = root && root.querySelector('h1, .t4s-product__title, .rb-product__name');
    if (heading) title = heading.textContent || '';
    var path = '';
    try {
      path = new URL(window.location.href).pathname;
    } catch (err) {}
    var blob = (title + ' ' + path).toLowerCase();
    if (blob.indexOf('bundle-builder') !== -1 || blob.indexOf('byob') !== -1) return 'rb';
    if (blob.indexOf('kratom') !== -1 || blob.indexOf('kava') !== -1) return 'kratom';
    return 'canna';
  }

  function productIsKratom(root) {
    return productBrandKey(root) === 'kratom';
  }

  function setCardBrand(root) {
    var card = cardEl();
    if (!card) return;
    var brandEl = card.querySelector('.rb-pdp-card__brand');
    if (!brandEl) return;
    brandEl.setAttribute('data-rb-pdp-brand', productBrandKey(root || card));
  }

  function injectCard(card, html) {
    var body = bodyEl(card) || scrollEl(card);
    if (!body) return null;
    body.innerHTML = html;
    stripGhostLineItemField(body);
    var heading = body.querySelector('h1, .t4s-product__title, .rb-product__name');
    if (heading) heading.id = 'rb-pdp-card-title';
    setCardBrand(body);
    scheduleMountPdpMast(card);
    resetCardScroll(card);
    try {
      if (typeof window.rbPeekVariantGlow === 'function') {
        window.rbPeekVariantGlow(body);
      }
    } catch (errGlow) {}
    initCardPurchase(body);
    /* Keep is-loading until settleCard — avoids media/info shuffle while widgets paint */
    return body;
  }

  function fillCard(card, html) {
    var body = injectCard(card, html);
    if (!body) return;
    return hydrate(body).then(function () {
      return waitMainImages(body, 300);
    }).then(function () {
      return settleCard(card, body);
    });
  }

  function fetchProduct(url) {
    var href = withPreview(url);
    if (fullPageHrefs[href]) return Promise.reject(new Error('pdp-full-page'));
    if (cache[href]) return Promise.resolve(cache[href]);
    if (inflight[href]) return inflight[href];

    function parseAndStore(text) {
      if (!text) throw new Error('pdp-fetch');
      var parsed = parseMain(text);
      if (parsed.html && parsed.html.indexOf('data-rb-preorder-variants') !== -1) {
        fullPageHrefs[href] = true;
        throw new Error('pdp-full-page');
      }
      cache[href] = parsed;
      preloadParsedImages(parsed);
      return parsed;
    }

    var warm = takeWarmHtml(href);
    if (warm) {
      return Promise.resolve(parseAndStore(warm));
    }

    var warmer = window.__rbPdpWarm;
    if (typeof warmer === 'function') {
      inflight[href] = Promise.resolve(warmer(href))
        .then(parseAndStore)
        .finally(function () {
          delete inflight[href];
        });
      return inflight[href];
    }

    inflight[href] = fetch(href, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('pdp-fetch');
        return res.text();
      })
      .then(parseAndStore)
      .finally(function () {
        delete inflight[href];
      });
    return inflight[href];
  }

  function takeWarmHtml(href) {
    var bag = window.__rbPdpWarmHtml;
    if (!bag) return '';
    if (bag[href]) return bag[href];
    var want = '';
    try {
      want = new URL(href, window.location.origin).pathname;
    } catch (err) {
      return '';
    }
    var match = '';
    Object.keys(bag).forEach(function (key) {
      if (match) return;
      try {
        if (new URL(key, window.location.origin).pathname === want) match = bag[key];
      } catch (err2) {}
    });
    return match;
  }

  function preloadParsedImages(parsed) {
    if (!parsed || !parsed.html) return;
    try {
      var wrap = document.createElement('div');
      wrap.innerHTML = parsed.html;
      var imgs = wrap.querySelectorAll(
        '.t4s-product__media-wrapper img, .t4s-product__media img, [data-main-media] img'
      );
      var n = 0;
      imgs.forEach(function (img) {
        if (n >= 4) return;
        var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
        if (!src || src.indexOf('data:') === 0) return;
        n += 1;
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = src;
      });
    } catch (err) {}
  }

  function productCardHref(node) {
    var a = node.tagName === 'A' ? node : node.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var href = a.getAttribute('href');
    if (!href || !isProductUrl(href)) return '';
    try {
      return new URL(href, window.location.origin).toString();
    } catch (err) {
      return '';
    }
  }

  function collectListingProductUrls() {
    var inView = [];
    var rest = [];
    var seen = {};
    var nodes = document.querySelectorAll('a[href*="/products/"]');
    var vh = window.innerHeight || 800;
    nodes.forEach(function (a) {
      var href = productCardHref(a);
      if (!href || seen[href]) return;
      var handle = productPath(new URL(href, window.location.origin).pathname);
      if (!handle || handle === 'navidium-shipping-protection') return;
      seen[href] = true;
      var rect = a.getBoundingClientRect();
      var visible = rect.bottom > 0 && rect.top < vh + 200;
      if (visible) inView.push(href);
      else rest.push(href);
    });
    return inView.concat(rest);
  }

  /* rb-pdp-card-prefetch-v4 — warm visible cards first, 4 at a time */
  function prefetchListingPdps() {
    var card = cardEl();
    if (!card || isNative(card)) return;
    var urls = collectListingProductUrls().slice(0, 36);
    var i = 0;
    var workers = 4;
    function next() {
      if (i >= urls.length) return;
      var url = urls[i++];
      var href = withPreview(url);
      if (cache[href] || prefetchQueued[href]) {
        next();
        return;
      }
      prefetchQueued[href] = true;
      fetchProduct(url)
        .catch(function () {
          delete prefetchQueued[href];
        })
        .then(next);
    }
    for (var w = 0; w < workers; w++) next();
  }

  function schedulePrefetch() {
    prefetchListingPdps();
    window.setTimeout(prefetchListingPdps, 800);
    window.setTimeout(prefetchListingPdps, 2500);
  }

  function prefetchFromLink(node) {
    var href = productCardHref(node);
    if (!href) return;
    fetchProduct(href).catch(function () {});
  }

  function watchNewListingCards() {
    var root = document.getElementById('MainContent');
    if (!root || !window.MutationObserver) return;
    var timer;
    var obs = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(prefetchListingPdps, 400);
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  var RETURN_KEY = 'rb-pdp-return-v1';

  function listingHref() {
    return window.location.pathname + window.location.search;
  }

  function isListingPage() {
    return !productPath(window.location.pathname);
  }

  function rememberReturn(handle) {
    if (!handle) return;
    try {
      if (isListingPage()) {
        sessionStorage.setItem(
          RETURN_KEY,
          JSON.stringify({ href: listingHref(), handle: handle })
        );
        return;
      }
      var existing = readReturn();
      if (existing && existing.href && !productPath(existing.href)) {
        existing.handle = handle;
        sessionStorage.setItem(RETURN_KEY, JSON.stringify(existing));
      }
    } catch (err) {}
  }

  function readReturn() {
    try {
      var raw = sessionStorage.getItem(RETURN_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.href) return null;
      return data;
    } catch (err) {
      return null;
    }
  }

  function clearReturn() {
    try {
      sessionStorage.removeItem(RETURN_KEY);
    } catch (err) {}
  }

  function storedListingUrl() {
    var data = readReturn();
    if (!data || !data.href || productPath(data.href)) return '';
    var current = productPath(window.location.pathname);
    if (current && data.handle && data.handle !== current) return '';
    try {
      var u = new URL(data.href, window.location.origin);
      if (u.origin !== window.location.origin) return '';
      return withPreview(u.pathname + u.search);
    } catch (err) {
      return '';
    }
  }

  /* rb-pdp-variant-url-v1 — theme never writes ?variant= here, so the URL cannot be
     copied or shared for a specific variant. Mirror the selected variant into the URL. */
  var variantUrlLast = '';
  var variantUrlTimers = [];

  function clearVariantUrlTimers() {
    variantUrlTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    variantUrlTimers = [];
  }

  function selectedVariantId(scope) {
    if (!scope) return '';
    var field = scope.querySelector('select[name="id"], input[name="id"]');
    if (field && field.value) return String(field.value);
    var checked = scope.querySelector('[name="id"]:checked');
    return checked && checked.value ? String(checked.value) : '';
  }

  function syncVariantUrl() {
    var card = cardEl();
    if (!card) return;
    if (!isNative(card) && !card.classList.contains('is-open')) return;
    if (!isProductUrl(window.location.pathname)) return;
    var id = selectedVariantId(card);
    if (!id || id === variantUrlLast) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      var state = window.history.state && typeof window.history.state === 'object'
        ? Object.assign({}, window.history.state)
        : {};
      window.history.replaceState(state, '', url.pathname + url.search + url.hash);
      variantUrlLast = id;
    } catch (err) {}
  }

  function scheduleVariantUrlSync() {
    clearVariantUrlTimers();
    /* Swatch click updates the select asynchronously — re-read until it settles */
    [0, 120, 350, 800].forEach(function (ms) {
      variantUrlTimers.push(window.setTimeout(syncVariantUrl, ms));
    });
  }

  function bindVariantUrlSync() {
    if (bindVariantUrlSync.bound) return;
    bindVariantUrlSync.bound = true;
    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (!t.closest('[data-value],[data-swatch-item],[data-swatch-option],.t4s-swatch__item')) return;
        var card = cardEl();
        if (!card || !card.contains(t)) return;
        scheduleVariantUrlSync();
      },
      true
    );
    document.addEventListener(
      'change',
      function (event) {
        var t = event.target;
        if (!t || t.name !== 'id') return;
        var card = cardEl();
        if (!card || !card.contains(t)) return;
        scheduleVariantUrlSync();
      },
      true
    );
    /* Theme fires this through jQuery, so it never reaches a native listener */
    if (window.jQuery) {
      try {
        window.jQuery(document).on('variant:changed', scheduleVariantUrlSync);
      } catch (err) {}
    }
  }

  function patchOverlayHistory() {
    if (history.pushState && !history.pushState._rbPdp) {
      var origPush = history.pushState.bind(history);
      history.pushState = function (state, title, url) {
        if (document.documentElement.classList.contains(OPEN_CLASS)) {
          var card = cardEl();
          if (card && !isNative(card) && window.history.state && window.history.state.rbPdpCard) {
            var next = state && typeof state === 'object' ? Object.assign({}, state, { rbPdpCard: true }) : { rbPdpCard: true };
            return window.history.replaceState(next, title, url);
          }
        }
        return origPush(state, title, url);
      };
      history.pushState._rbPdp = true;
    }
  }

  function openFromListing(url, push) {
    var card = cardEl();
    if (!card || isNative(card) || opening) return;
    opening = true;
    rememberReturn(productPath(url));
    var href = withPreview(url);
    var parsed = cache[href];
    layoutLocked = false;
    window.clearTimeout(settleUnlockTimer);
    setOpen(card, true);
    applyProductBodyClass();
    revealCardNav({ quietMs: 700 });
    card.classList.add('is-loading');
    function show(parsedShow) {
      if (parsedShow.title) document.title = parsedShow.title;
      if (push !== false) {
        window.history.pushState({ rbPdpCard: true }, parsedShow.title, url);
      }
      var root = injectCard(card, parsedShow.html);
      opening = false;
      resetCardScroll(card);
      var prep = root ? hydrate(root) : Promise.resolve();
      Promise.resolve(prep)
        .then(function () {
          return waitMainImages(root, 300);
        })
        .then(function () {
          return settleCard(card, root || card);
        })
        .catch(function () {
          markPdpReady(root || card);
          card.classList.remove('is-loading');
          layoutLocked = false;
        });
    }
    if (parsed) {
      show(parsed);
      return;
    }
    fetchProduct(url)
      .then(show)
      .catch(function () {
        window.location.href = url;
      })
      .then(function () {
        opening = false;
      });
  }

  function hideOverlay(card) {
    clearPurchaseRetries();
    layoutLocked = false;
    window.clearTimeout(settleUnlockTimer);
    window.clearTimeout(layoutSyncTimer);
    destroyCardWidgets(card);
    setOpen(card, false);
    card.classList.remove('is-loading');
    var body = bodyEl(card);
    if (body) body.innerHTML = '';
  }

  function closeAjax(card) {
    /* rb-pdp-close-once-v1 — hide now; put listing URL in place so variant/S&S history does not need a second click */
    closingOverlay = true;
    hideOverlay(card);
    var listing = storedListingUrl();
    try {
      if (listing) {
        window.history.replaceState({ rbPdpCardClosed: true }, '', listing);
      } else if (window.history.state && window.history.state.rbPdpCard) {
        window.history.back();
      }
    } catch (err) {}
    window.setTimeout(function () {
      closingOverlay = false;
    }, 200);
  }

  function closeNative() {
    clearPurchaseRetries();
    markClosed();
    var backTo = storedListingUrl();
    if (backTo) {
      clearReturn();
      window.location.href = backTo;
      return;
    }
    var ref = document.referrer;
    if (window.history.length > 1 && ref && sameOrigin(ref) && !productPath(ref)) {
      window.history.back();
      return;
    }
    if (window.history.length > 1 && ref && sameOrigin(ref)) {
      window.history.back();
      return;
    }
    window.location.href = '/';
  }

  function closeCard() {
    var card = cardEl();
    if (!card || !card.classList.contains('is-open')) return;
    if (isNative(card)) {
      closeNative();
      return;
    }
    closeAjax(card);
  }

  function shouldIntercept(event, a) {
    if (event.defaultPrevented) return false;
    if (event.button && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (!a || a.hasAttribute('download')) return false;
    if (a.target && a.target !== '' && a.target !== '_self') return false;
    if (a.hasAttribute('data-action-quickview') || a.hasAttribute('data-action-quickshop')) {
      /* still intercept — we replaced truncated QV */
    }
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    if (!isProductUrl(href)) return false;
    if (fullPageHrefs[withPreview(href)]) return false;
    var dest = new URL(href, window.location.origin);
    if (dest.pathname === window.location.pathname && dest.search === window.location.search) {
      return false;
    }
    return true;
  }

  function onClick(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!shouldIntercept(event, a)) return;
    var card = cardEl();
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    var href = new URL(a.getAttribute('href'), window.location.origin).toString();
    noteListingAnchor(a);
    rememberReturn(productPath(href));
    if (isNative(card)) {
      opening = true;
      card.classList.add('is-loading');
      fetchProduct(href)
        .then(function (parsed) {
          if (parsed.title) document.title = parsed.title;
          window.history.pushState({ rbPdpCard: true }, parsed.title, href);
          return fillCard(card, parsed.html);
        })
        .catch(function () {
          window.location.href = href;
        })
        .then(function () {
          opening = false;
          var scroll = scrollEl(card);
          if (scroll) scroll.scrollTop = 0;
        });
      return;
    }
    openFromListing(href, true);
  }

  function onPopState() {
    /* rb-pdp-browser-back-v1 — browser Back closes the overlay and stays on the previous page */
    var card = cardEl();
    if (!card || closingOverlay) return;
    if (isNative(card)) return;
    if (!card.classList.contains('is-open')) return;
    closingOverlay = true;
    hideOverlay(card);
    if (isProductUrl(window.location.href)) {
      var listing = storedListingUrl();
      if (listing) {
        try {
          window.history.replaceState({ rbPdpCardClosed: true }, '', listing);
        } catch (err) {}
      }
    }
    window.setTimeout(function () {
      closingOverlay = false;
    }, 200);
  }

  function onBackLinkClick(event) {
    /* rb-pdp-back-sync-v1 — back arrow uses same close path as X (not history.go first) */
    var back = event.target && event.target.closest
      ? event.target.closest('a.backlink.rb-pdp-back, a.rb-pdp-back.backlink')
      : null;
    if (!back) return;
    var card = cardEl();
    if (!card || !card.classList.contains('is-open') || isNative(card)) return;
    if (!document.documentElement.classList.contains(OPEN_CLASS)) return;
    event.preventDefault();
    event.stopPropagation();
    closeCard();
  }

  /* rb-media-sharp-v2 — render_bottom's inline first-paint script gives the images in view a
     final src picked from their clientWidth at that instant (class lazyloadt4s-opt), and lazysizes
     fixes `sizes` the same way. Measured before the gallery has laid out, either can settle on the
     100–200px file, which then stays blurry for good. Re-pick for the width the image renders at. */
  function sharpenOptImage(img, cssWidth) {
    var sizes = parseFloat(img.getAttribute('sizes'));
    if (img.getAttribute('srcset') && sizes && sizes < cssWidth * 0.8) {
      img.setAttribute('sizes', Math.round(cssWidth) + 'px');
    }
    var src = img.getAttribute('src') || '';
    var m = src.match(/[?&]width=(\d+)/);
    if (!m || !cssWidth) return;
    var widths;
    try {
      widths = JSON.parse(img.getAttribute('data-widths') || '[]');
    } catch (err) {
      return;
    }
    if (!widths.length) return;
    var current = parseInt(m[1], 10);
    var need = cssWidth * (parseFloat(img.getAttribute('data-sizes-scale')) || 1) * (window.devicePixelRatio || 1);
    if (current >= need * 0.8) return;
    var pick = widths.filter(function (w) { return w >= need; })[0] || widths[widths.length - 1];
    if (pick > current) img.setAttribute('src', src.replace(/([?&]width=)\d+/, '$1' + pick));
  }

  var mediaSizeObserver = null;

  function watchMediaSize(img) {
    if (!mediaSizeObserver || !img || img.tagName !== 'IMG' || img._rbSizeWatch) return;
    img._rbSizeWatch = true;
    mediaSizeObserver.observe(img);
  }

  function bindMediaSize() {
    if (!window.ResizeObserver || mediaSizeObserver) return;
    mediaSizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        sharpenOptImage(entry.target, entry.contentRect.width);
      });
    });
    document.querySelectorAll('img.lazyloadt4s-opt, .t4s-product__media-wrapper img[data-sizes="auto"]').forEach(watchMediaSize);
    /* Gallery images that arrive later (the rb-pdp-card overlay) are sized by lazysizes too */
    document.addEventListener('lazybeforesizes', function (event) {
      var img = event.target;
      if (img && img.closest && img.closest('.t4s-product__media-wrapper')) watchMediaSize(img);
    }, true);
  }

  /* rb-stoq-preorder-label-v1 — the theme rewrites the button to Add To Cart on every variant
     change and Stoq only relabels it a beat later. The theme triggers variant:changed through
     its own bundled jQuery, out of reach of listeners here, so watch the label instead; a
     MutationObserver callback runs before the next paint, so the wrong text never shows. */
  function bindPreorderLabel() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('[data-rb-preorder-variants]').forEach(function (btn) {
      var label = btn.querySelector('.t4s-btn-atc_text');
      if (!label || label._rbPreorder) return;
      label._rbPreorder = true;
      var ids = btn.getAttribute('data-rb-preorder-variants');
      new MutationObserver(function () {
        if (label.textContent === 'Preorder' || btn.hasAttribute('disabled')) return;
        var input = btn.form && btn.form.querySelector('[name="id"]');
        if (input && ids.indexOf(',' + input.value + ',') !== -1) label.textContent = 'Preorder';
      }).observe(label, { childList: true, characterData: true, subtree: true });
    });
  }

  function bind() {
    bindPreorderLabel();
    bindMediaSize();
    var card = cardEl();
    if (!card) return;
    scheduleMountPdpMast(card);
    window.addEventListener('resize', function () {
      scheduleMountPdpMast(cardEl());
    });
    if (isNative(card)) {
      markOpen();
      lockCardScrollY(card);
      pinQuickshopTop(card);
      startCardHeaderScroll(card);
      setCardBrand(card);
      schedulePdpLayout(card);
      var nativeBackup = backupPurchase(card);
      initCardPurchase(card);
      schedulePurchaseRetries(card, nativeBackup);
      markPdpReady(card);
    }
    document.addEventListener('click', onClick, true);
    document.addEventListener('click', onBackLinkClick, true);
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-rb-pdp-close]') : null;
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      closeCard();
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var c = cardEl();
      if (!c || !c.classList.contains('is-open')) return;
      closeCard();
    });
    window.addEventListener('popstate', onPopState);
    patchOverlayHistory();
    bindVariantUrlSync();
    document.addEventListener('pointerover', function (event) {
      var a = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      prefetchFromLink(a);
    }, true);
    document.addEventListener(
      'pointerdown',
      function (event) {
        var a = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
        if (!a) return;
        prefetchFromLink(a);
      },
      true
    );
    if (!isNative(card)) {
      schedulePrefetch();
      watchNewListingCards();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
